<template>
  <div>
    <div class="mt-5 pt-4">
      <nav class="mb-5" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='black'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" style="font-size:24px; line-height: 24px; font-weight:900; color:#435666;"><strong>Settings</strong></li>
          <li class="breadcrumb-item active" aria-current="page" style="font-size:24px; line-height: 24px; font-weight:300; color:#435666;">Libary</li>
        </ol>
      </nav>


			<div class="mt-4">
				<div class="row">
					<div class="col-md-12">
						<div class="card shadow p-3 mb-5 bg-white rounded border-0">
							<div class="card-body">
                <div class="row mb-4">
                  <div class="col-md-6 col-xs-12">
                    <div class="d-flex flex-row ">
                      <div class="align-middle p-2 col-5" style="font-size:14px;">
                        <div class="input-group">
                          <input type="text" class="form-control" placeholder="Search training..." aria-label="Username" v-model="search" aria-describedby="search">
                        </div>
                      </div>
                      <div class="align-middle p-2 col-6">
                        <button type="button" class="btn btn-outline-primary btn-create" @click="videoDialog = true;" v-tooltip.top="'Add New Training Video'">Create</button>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-xs-12">
                    <div class="d-flex flex-row-reverse">
                      <div class="align-middle p-2 col-xs-12">
                        <!-- <div class="btn-group" role="group" aria-label="Basic mixed styles example">
                          <button type="button" class="btn btn-square btn-labeled" :class="view.list ? 'btn-info text-white' : 'btn-default text-info'" :aria-pressed="view.list" @click="view.list = !view.list, view.grid = !view.list" v-tooltip.top="'Switch to List View'"><span class="btn-label"><i class="fas fa-list"></i></span></button>
                          <button type="button" class="btn btn-square btn-labeled" :class="view.grid ? 'btn-info text-white' : 'btn-default text-info'" :aria-pressed="view.grid" @click="view.grid = !view.grid, view.list = !view.grid" v-tooltip.top="'Switch to Tile View'"><span class="btn-label"><i class="fas fa-border-all"></i></span></button>
                        </div> -->
                      </div>
                      <div class="col-xs-12 p-3" style="font-size:14px;">
                        <div class="dropdown-toggle text-default" id="sortBy" data-bs-toggle="dropdown" aria-expanded="false">
                          <span> <strong>Sort by: </strong></span>
                          <span class="text-info" style="cursor:pointer;">Assign Sequence </span>
                          <ul class="dropdown-menu w-25" aria-labelledby="sortBy">
                            <li><span class="dropdown-item" v-for="(item,index) in sortByOptions" :key="index" @click="sortBy = item.value"> {{item.label}} </span></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div class="mt-5">
                    <div class="row">

                      <div v-if="loading" class="text-center align-middle">
                        <img src="@/assets/img/loading.svg">
                      </div>

                      <div v-if="trainingVideos.length == 0 && !loading" class="text-center">
                        <div class="card-body align-middle text-default" style="margin: auto; width: 50%; padding: 100px;">
                          <h2>No Data</h2>
                        </div>
                      </div>
                      <div class="col-12">
                        <h2>Training Videos</h2>
                      </div>

                      <!-- grid view -->
                      <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-2" v-for="(item, index) in trainingVideos" :key="index">
                        <div class="card-body text-default" v-if="!loading">
                          <div>
                            <video @click="this.$router.push({path: `training-library/${item.ID}/video`})" style="cursor:pointer;" class="video" muted="true" :poster="$store.state.auth.isSuperAdmin ? item.thumbnail : item.training_video.thumbnail">
                              <source :src="$store.state.auth.isSuperAdmin ? item.url: item.training_video.url" />
                            </video>
                          </div>
                          <div class="pa-0">
                            <h6 style="font-size:14px; cursor:pointer;" @click="this.$router.push({path: `training-library/${item.ID}/video`})"><strong>{{ item.name}}</strong></h6>
                            <span><small class="text-muted">Assign Sequence: </small><strong>{{ item.assign_sequence }}</strong></span>
                            <br />
                            <span><small class="text-muted">Total Questions: </small> <strong>{{ item.total_question }}</strong></span>
                            <br>
                            <div class="inline-block">
                              <!-- Custom Slider -->
                              <label class="form-check form-switch custom-slider custom-icon-btn" v-tooltip.top="tooltipText(item.archived)">
                                <input class="form-check-input" type="checkbox" role="switch" v-model="item.archived" @click="archive(item)">
                                <span class="slider">
                                  <span class="slider-button"></span>
                                </span>
                              </label>

                              <button type="button" v-tooltip.top="'Manage Quiz'" class="btn btn-default btn-circle custom-spacing custom-icon-btn" @click="this.$router.push({path: `training-library/${item.ID}/quiz`})">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                                <span v-if="!loading">
                                  <quiz-icon />
                                </span>
                              </button>

                              <button type="button" v-tooltip.top="'Edit Video'" class="btn btn-default btn-circle custom-spacing custom-icon-btn" @click="setTrainingVideo(item)">
                                <i class="fa fa-pen"></i>
                              </button>

                              <button type="button" v-tooltip.top="'Add/Edit Captions'" class="btn btn-default btn-circle custom-icon-btn custom-spacing" data-bs-toggle="modal" @click="getCaptionsByVideoID(item.ID)">
                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M22 11C22 13.9174 20.8411 16.7153 18.7782 18.7782C16.7153 20.8411 13.9174 22 11 22C8.08262 22 5.28473 20.8411 3.22183 18.7782C1.15893 16.7153 0 13.9174 0 11C0 8.08262 1.15893 5.28473 3.22183 3.22183C5.28473 1.15893 8.08262 0 11 0C13.9174 0 16.7153 1.15893 18.7782 3.22183C20.8411 5.28473 22 8.08262 22 11ZM7.436 8.09875C8.37237 8.09875 9.00075 8.745 9.06812 9.62088H10.6453V9.46963C10.5724 7.8375 9.23725 6.71962 7.42362 6.71962C5.21813 6.71962 3.96137 8.16337 3.96137 10.5022V11.5294C3.96137 13.8669 5.20713 15.2831 7.42362 15.2831C9.23038 15.2831 10.5655 14.1941 10.6453 12.617V12.4603H9.06812C9.00075 13.3059 8.38475 13.904 7.436 13.904C6.281 13.904 5.62375 13.0515 5.62375 11.5294V10.5091C5.62375 8.98013 6.29475 8.09737 7.436 8.09737V8.09875ZM14.8665 8.09875C15.8015 8.09875 16.4312 8.745 16.4972 9.62088H18.0744V9.46963C18.0015 7.8375 16.6664 6.71962 14.8541 6.71962C12.6486 6.71962 11.3919 8.16337 11.3919 10.5022V11.5294C11.3919 13.8669 12.6363 15.2831 14.8541 15.2831C16.6609 15.2831 17.996 14.1941 18.0744 12.617V12.4603H16.4972C16.4312 13.3059 15.8153 13.904 14.8665 13.904C13.7115 13.904 13.0529 13.0515 13.0529 11.5294V10.5091C13.0529 8.98013 13.7239 8.09737 14.8665 8.09737V8.09875Z" fill="#00A0C1"/>
                                </svg>
                              </button>

                              <button type="button" class="btn btn-default btn-circle-danger custom-icon-btn custom-spacing" ms-1 v-tooltip.top="'Delete Video'" @click="deleteTrainingVideo(item.ID)">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M8 4H12C12 3.46957 11.7893 2.96086 11.4142 2.58579C11.0391 2.21071 10.5304 2 10 2C9.46957 2 8.96086 2.21071 8.58579 2.58579C8.21071 2.96086 8 3.46957 8 4ZM6 4C6 2.93913 6.42143 1.92172 7.17157 1.17157C7.92172 0.421427 8.93913 0 10 0C11.0609 0 12.0783 0.421427 12.8284 1.17157C13.5786 1.92172 14 2.93913 14 4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5C20 5.26522 19.8946 5.51957 19.7071 5.70711C19.5196 5.89464 19.2652 6 19 6H18.118L17.232 16.34C17.1468 17.3385 16.69 18.2686 15.9519 18.9463C15.2137 19.6241 14.2481 20.0001 13.246 20H6.754C5.75191 20.0001 4.78628 19.6241 4.04815 18.9463C3.31002 18.2686 2.85318 17.3385 2.768 16.34L1.882 6H1C0.734784 6 0.48043 5.89464 0.292893 5.70711C0.105357 5.51957 0 5.26522 0 5C0 4.73478 0.105357 4.48043 0.292893 4.29289C0.48043 4.10536 0.734784 4 1 4H6ZM13 10C13 9.73478 12.8946 9.48043 12.7071 9.29289C12.5196 9.10536 12.2652 9 12 9C11.7348 9 11.4804 9.10536 11.2929 9.29289C11.1054 9.48043 11 9.73478 11 10V14C11 14.2652 11.1054 14.5196 11.2929 14.7071C11.4804 14.8946 11.7348 15 12 15C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8946 14.5196 13 14.2652 13 14V10ZM8 9C7.73478 9 7.48043 9.10536 7.29289 9.29289C7.10536 9.48043 7 9.73478 7 10V14C7 14.2652 7.10536 14.5196 7.29289 14.7071C7.48043 14.8946 7.73478 15 8 15C8.26522 15 8.51957 14.8946 8.70711 14.7071C8.89464 14.5196 9 14.2652 9 14V10C9 9.73478 8.89464 9.48043 8.70711 9.29289C8.51957 9.10536 8.26522 9 8 9Z" fill="#EB1C24"/>
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

							</div>
						</div>
					</div>
				</div>
			</div>
    </div>
  </div>
  <!-- video dialog -->
  <vue-final-modal v-model="videoDialog" classes="modal-container" content-class="modal-content">
      <span class="modal__title">Video</span>
      <div class="modal__content mt-3 mb-4">
        <div v-if="saving" class="modal-body text-center align-middle">
            <div class="col-12">
              Saving...
            </div>

            <div class="col-12">
              <img src="@/assets/img/loading.svg">
            </div>
          </div>
          <div class="modal-body" v-show="!saving">
            <div class="col mb-5">
              <label for="formFile" class="form-label">Name</label>
              <div class="input-group" :class="{ 'mb-3': v$.trainingVideo.name.$errors.length == 0 }">
                <button class="btn btn-info" style="color:white;"  @click="onFilePick('video')"><i class="fa fa-cloud"> <span class="font-default" > {{ ' ' + setUploadVideoButtonText }}</span></i></button>
                <input type="file" style="display: none" ref="videoInput" accept="*/*" @change="onVideoPicked">
                <input class="form-control" type="text" placeholder="Name" aria-label="Name" v-model="trainingVideo.name">
              </div>
              <div class="text-danger" v-for="error of v$.trainingVideo.name.$errors" :key="error.$uid">
                <div class="form-text text-danger">{{ error.$message }}</div>
              </div>
              <label for="formFile" class="form-label">Thumbnail</label>
              <div class="input-group" :class="{ 'mb-3': v$.trainingVideo.name.$errors.length == 0 }">
                <button class="btn btn-info" style="color:white;"  @click="onFilePick('thumbnail')"><i class="fa fa-cloud"> <span class="font-default"> {{ ' ' + setUploadThumbnailButtonText }}</span></i></button>
                <input type="file" style="display: none" ref="thumbInput" accept="*/*" @change="onThumbPicked">
                <input class="form-control" type="text" placeholder="Thumbnail" aria-label="Thumbnail" v-model="trainingVideo.thumbnail">
              </div>
              <div class="text-danger" v-for="error of v$.trainingVideo.thumbnail.$errors" :key="error.$uid">
                <div class="form-text text-danger">{{ error.$message }}</div>
              </div>
              <div>
                <label for="takeawayFile" class="form-label">Take away</label>
                <FileUploader ref="takeawayFileRef" :id="'takeawayFile'" @fileListChange="takeawayHandler" :acceptedFileType="'pdf'" key="takeawayFile" v-if="videoDialog"/>
              </div>
              <div class="fileList mx-2" v-show="trainingVideo.takeaway">
                <div>
                  <div>
                  <span class="p-2">{{ trainingVideo.takeaway }}</span>
                  <span class="removeFile" @click="removeFile(trainingVideo.id)" title="Click to remove file"><i class="fa fa-times fa-xs"></i></span>
                  </div>
                </div>
              </div>
              <div class="mb-1">
                <label for="formFile" class="form-label">Assign Sequence</label>
                <input class="form-control" type="text" placeholder="eg: en, no..." v-model="trainingVideo.assignSequence">
                <div class="text-danger" v-for="error of v$.trainingVideo.assignSequence.$errors" :key="error.$uid">
                  <div class="form-text text-danger">{{ error.$message }}</div>
                </div>
              </div>
            </div>
          </div>
      </div>
      <div class="modal__action">
        <button type="button" class="btn btn-outline-danger" @click="closeDialog">Close</button>
        <button class="btn btn-outline-primary" style="text-transform:capitalize;" type="button" @click="saveTrainingVideo" :disabled="saving">
          {{buttonSave}}
        </button>
      </div>
    </vue-final-modal>
    <!-- video dialog -->

  <!-- caption dialog -->
  <vue-final-modal v-model="captionDialog" classes="modal-container" content-class="modal-content-caption">
    <span class="modal__title">Captions</span>
    <div class="modal__content mt-3 mb-4">
      <div class="col mb-5">
        <label for="formFile" class="form-label">Filename</label>
        <div class="input-group mb-3">
          <button class="btn btn-info" style="color:white;"  @click="onFilePick('caption')"><i class="fa fa-cloud"><span class="font-default">{{ ' ' + setUploadCaptionButtonText }}</span></i></button>
          <input type="file" style="display: none" ref="captionInput" accept="*/*" @change="onCaptionPicked">
          <input class="form-control" type="text" placeholder="Filename" aria-label="Filename" v-model="caption.filename">
        </div>
        <div class="mb-1">
          <label for="formFile" class="form-label">Label</label>
          <input class="form-control" type="text" placeholder="eg: English, Norwegian..." v-model="caption.label">
        </div>
        <div class="mb-1">
          <label for="formFile" class="form-label">Source Lang</label>
          <input class="form-control" type="text" placeholder="eg: en, no..." v-model="caption.sourceLang">
        </div>
<!--
        <div class="row px-5">
          <button class="btn btn-info mt-2" style="color:white; text-transform:capitalize;" @click="saveCaption()">{{captionButtonState}}</button>
        </div>
        <div class="row px-5">
          <button class="btn btn-light mt-2" style="color:grey;" @click="clearInputCaption">Clear</button>
        </div> -->

        <div class="col-12 mb-5">
            <div class="text-center p-1">
              <button type="button" class="btn btn-outline-primary ms-3 col-10" style="padding-right:19px; text-transform:capitalize;" @click="saveCaption()">{{ captionButtonState }}</button>
            </div>
            <div class="text-center p-1">
              <button type="button" class="btn btn-outline-clear ms-3 col-10" @click="clearInputCaption">Clear</button>
            </div>
          </div>
      </div>

      <div class="col" style="overflow-x:auto; overflow-y: auto; max-height:300px;" >
        <div v-if="captionLoading" class="text-center align-middle">
          <img src="@/assets/img/loading.svg">
        </div>
        <table class="table" v-else>
          <thead>
            <tr class="table-light">
              <td>FileName</td>
              <td>Source</td>
              <td>Label</td>
              <td>Source Languange</td>
              <td>Actions</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in captions" :key="index">
              <td>{{ item.filename }}</td>
              <td style="text-overflow: ellipsis;">{{ item.source_url }}</td>
              <td>{{ item.label }}</td>
              <td>{{ item.source_lang }}</td>
              <td>
                <button type="button" class="btn btn-default btn-circle ms-1" ms-1 title="Add/Edit Captions" @click="editCaption(item)"><i class="fas fa-edit"></i></button>
                <button type="button" class="btn btn-default btn-circle-danger ms-1" ms-1 title="Delete Video" @click="deleteCaption(item)"><i class="fas fa-trash"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal__action">
      <button type="button" class="btn btn-outline-danger" @click="closeCaptionDialog">Close</button>
    </div>
  </vue-final-modal>

  <div class="modal fade modal-lg" id="captionsDialog" tabindex="-1" aria-hidden="true" >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Captions</h5>
          </div>
          <div class="modal-body">
              <div class="col mb-5">
                <label for="formFile" class="form-label">Filename</label>
                <div class="input-group mb-3">
                  <button class="btn btn-info" style="color:white;"  @click="onFilePick('caption')"><i class="fa fa-cloud">{{ ' ' + setUploadCaptionButtonText }}</i></button>
                  <input type="file" style="display: none" ref="captionInput" accept="*/*" @change="onCaptionPicked">
                  <input class="form-control" type="text" placeholder="Filename" aria-label="Filename" v-model="caption.filename">
                </div>
                <div class="mb-1">
                  <label for="formFile" class="form-label">Label</label>
                  <input class="form-control" type="text" placeholder="eg: English, Norwegian..." v-model="caption.label">
                </div>
                <div class="mb-1">
                  <label for="formFile" class="form-label">Source Lang</label>
                  <input class="form-control" type="text" placeholder="eg: en, no..." v-model="caption.sourceLang">
                </div>

                <div class="row px-5">
                  <button class="btn btn-info mt-2" style="color:white; text-transform:capitalize;" @click="saveCaption()">{{captionButtonState}}</button>
                </div>
                <div class="row px-5">
                  <button class="btn btn-light mt-2" style="color:grey;" @click="clearInputCaption">Clear</button>
                </div>
              </div>

            <div class="col">
              <div v-if="captionLoading" class="text-center align-middle">
                <img src="@/assets/img/loading.svg">
              </div>
              <table class="table" v-else>
                <thead>
                    <tr class="table-light">
                      <td>FileName</td>
                      <td>Source</td>
                      <td>Label</td>
                      <td>Source Languange</td>
                      <td>Actions</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in captions" :key="index">
                      <td>{{ item.filename }}</td>
                      <td>{{ item.source_url }}</td>
                      <td>{{ item.label }}</td>
                      <td>{{ item.source_lang }}</td>
                      <td>
                        <button type="button" class="btn btn-default btn-circle ms-1" ms-1 title="Add/Edit Captions" @click="editCaption(item)"><i class="fas fa-edit"></i></button>
                        <button type="button" class="btn btn-default btn-circle-danger ms-1" ms-1 title="Delete Video" @click="deleteCaption(item)"><i class="fas fa-trash"></i></button>
                      </td>
                    </tr>
                  </tbody>
              </table>
            </div>
            </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
      </div>
    </div>
  </div>
  <!-- caption dialog -->
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { debounce } from '@/plugins/helper.js'
import FileUploader from '@/components/FileUploader.vue';
import QuizIcon from '@/components/icons/QuizIcon.vue';


export default {
  name: "ScheduledJobs",

  components: {
      FileUploader,
      QuizIcon
   },

  setup() {
    return {
      v$: useVuelidate(),
    }
  },

  validations () {
    return {
      trainingVideo: {
        fileObject: {required},
        thumbnail: {required},
        name: {required},
        assignSequence: {required},
      },
    }
  },


  data() {
    return {
      loading: false,
      videoDialog: false,
      captionDialog: false,
      saving: false,
      search: "",

      fileName: '',
      url: '',
      fileObject: null,
      isSelecting: false,
      thumbName: '',
      thumbUrl: '',
      thumbObject: null,
      takeawayObject: null,
      buttonSave: 'save',

      trainingVideos: [],
      trainingVideo: {
        id: '',
        name: '',
        assignSequence: 0,
        aboveContent: '',
        belowContent: '',
        documentationLink: '',
        oldSequence: 0,
        takeaway: null,
      },

      captions:[],
      caption: {
        id: null,
        filename: '',
        sourceURL: '',
        sourceLang: '',
        label: '',
      },

      sortBy: null,
      sortByOptions:[
        {
          label: "Assign Sequence",
          value: "assign_sequence"
        },
        {
          label: "Created Date",
          value: "created_at"
        },
    ],

      captionLoading: false,
      captionButtonState: 'save',
      captionName: null,
      captionObject: null,
      id: null,
    }
  },

  async created() {
    await this.getData();
  },

  methods: {
    getData() {
      this.loading = true;

      let params = {
        filter: this.search,
        sort: this.sortBy ? this.sortBy.value : ''
      }

      this.$axios.get('/supadmin/trainings/videos?', {params})
      .then((response) => {
          if (response.data.success){
            this.trainingVideos = response.data.training_videos;
            this.maxSequence(response.data.training_videos)
          } else {
            this.$toast.error(response.data.message)
          }
        this.loading = false;
      })
      .catch()
    },

    setTrainingVideo(item){
      this.trainingVideo.oldSequence = item.assign_sequence
      this.id = item.ID;
      this.buttonSave = 'update';
      this.$axios.get("/supadmin/trainings/videos/"+ item.ID)
      .then((response) => {
          if (response.data.success){
            this.videoDialog = true;
            this.trainingVideo.id = item.ID
            this.trainingVideo.name = response.data.training_video.name;
            this.trainingVideo.assignSequence = response.data.training_video.assign_sequence;
            this.trainingVideo.aboveContent = response.data.training_video.above_content;
            this.trainingVideo.belowContent = response.data.training_video.below_content;
            this.trainingVideo.documentationLink = response.data.training_video.documentation_link;
            this.trainingVideo.thumbnail = response.data.training_video.thumbnail
            this.trainingVideo.takeaway = response.data.training_video.takeaway
          } else {
              this.$toast.error(response.data.message)
          }
      })
      .catch()
    },

    maxSequence(videos){
      if (videos == null && videos.length == 0) {
        videos.assignSequence = 1
        return
      }

      let max = 0;
      videos.forEach(v => {
        if (parseInt(v.assign_sequence) >= parseInt(max)) {
          max = v.assign_sequence
        }
      });

      this.trainingVideo.assignSequence = parseInt(max) + 1
    },

    archive(item){
      let data = {
        archived: !item.archived,
      }

      this.$axios.put('/supadmin/trainings/videos/'+ item.ID +'/archive', data)
      .then((response) => {
        if (response.data.success && item.archived == true)
         this.$toast.success('Successfully archived video.')
        else
          this.$toast.success('Video removed from archive.')
      })
      .catch()
    },

    onFilePick (value) {
      this.isSelecting = true
      window.addEventListener('focus', () => {
      this.isSelecting = false
      }, { once: true })

      switch (value) {
        case 'video':
          this.$refs.videoInput.click();
          break;
        case 'thumbnail':
          this.$refs.thumbInput.click();
          break;
        case 'caption':
          this.$refs.captionInput.click();
          break;
      }
    },

    onVideoPicked (event) {
      const files = event.target.files

      if (files[0] !== undefined) {
          this.fileName = files[0].name;

          // Check validity of file
          if (this.fileName.lastIndexOf('.') <= 0) {
              return
          }

          // If valid, continue
          const fr = new FileReader()
          fr.readAsDataURL(files[0])

          fr.addEventListener('load', () => {
              this.url = fr.result
              this.fileObject = files[0] // this is a file that can be sent to server...

              this.$refs.videoInput.value = ''
          })
      } else {
          this.fileName = ''
          this.fileObject = null
          this.url = ''
      }

      this.trainingVideo.name = this.fileName ? this.fileName : "";
    },

    onThumbPicked (event) {
      const files = event.target.files

      if (files[0] !== undefined) {
        this.thumbName = files[0].name;

        // Check validity of file
        if (this.thumbName.lastIndexOf('.') <= 0) {
            return
        }

        // If valid, continue
        const fr = new FileReader()
        fr.readAsDataURL(files[0])

        fr.addEventListener('load', () => {
            this.thumbUrl = fr.result
            this.thumbObject = files[0] // this is a file that can be sent to server...

            this.$refs.thumbInput.value = ''
        })
      } else {
        this.thumbName = ''
        this.thumbObject = null
        this.thumbUrl = ''
      }

      this.trainingVideo.thumbnail = this.thumbName ? this.thumbName : "";
    },

    onCaptionPicked (event) {
      const files = event.target.files

      if (files[0] !== undefined) {
        this.captionName = files[0].name;

        // Check validity of file
        if (this.captionName.lastIndexOf('.') <= 0) {
            return
        }

        // If valid, continue
        const fr = new FileReader()
        fr.readAsDataURL(files[0])

        fr.addEventListener('load', () => {
          this.captionObject = files[0] // this is a file that can be sent to server...
          this.$refs.captionInput.value = ''
        })
      } else {
        this.captionName = ''
        this.captionObject = null
      }

      this.caption.filename = this.captionName ? this.captionName : "";
    },

    closeCaptionDialog(){
      this.captionName = '';
      this.captionDialog = false;
      this.captionObject = null;
      this.v$.$reset();
      this.captionButtonState = 'save'
    },

    clearInputCaption() {
      this.caption.id = null
      this.caption.filename = ''
      this.caption.sourceURL = ''
      this.caption.sourceLang = ''
      this.caption.label = ''

      this.captionButtonState = "save"
      this.captionName = ''
      this.captionObject = null
    },

    editCaption(item) {
      this.caption.id = item.ID
      this.caption.filename = item.filename
      this.caption.sourceURL = item.source_url
      this.caption.sourceLang = item.source_lang
      this.caption.label = item.label

      this.captionButtonState = "update"
    },

    async saveTrainingVideo(){
      this.v$.trainingVideo.name.$touch();
      this.v$.trainingVideo.thumbnail.$touch();
      this.v$.trainingVideo.assignSequence.$touch();
      if (this.v$.trainingVideo.name.$invalid || this.v$.trainingVideo.thumbnail.$invalid || this.v$.trainingVideo.assignSequence.$invalid ) return

      this.saving = true;

      let formData = new FormData();
        formData.append('name', this.trainingVideo.name);

        if (this.fileObject != null)
          formData.append('file', this.fileObject);

        if (this.thumbObject != null)
          formData.append('thumbnail', this.thumbObject);

        if (this.trainingVideo.assignSequence != this.trainingVideo.oldSequence)
          formData.append('assign_sequence', this.trainingVideo.assignSequence);

        if (this.takeawayObject != null)
          formData.append('takeaway', this.takeawayObject);

      if (this.buttonSave == 'save'){
        this.$axios.post('/supadmin/trainings/videos', formData)
        .then((response) => {
          if (response.data.success){
            this.$toast.success(response.data.message)
            this.getData();

            this.closeDialog();
            this.saving = false;
          }
          else{
            this.$toast.error(response.data.message)
            this.saving = false;
          }

        })
        .catch()
      } else {
        this.$axios.put('/supadmin/trainings/videos/' + this.id, formData)
        .then((response) => {
          if (response.data.success){
            this.getData();
            this.$toast.success(response.data.message)

            this.closeDialog();
            this.saving = false;
          }
          else{
            this.$toast.error(response.data.message)
            this.saving = false;
          }
        })
        .catch()
      }
    },

    closeDialog(){
      this.id = "";
      this.videoDialog = false;
      this.trainingVideo = {};
      this.buttonSave = 'save';
      this.fileName = '';
      this.fileObject = null;
      this.thumbName = '';
      this.thumbObject = null;
      this.takeawayObject = null;
      this.maxSequence(this.trainingVideos)
      this.v$.$reset();
    },

    saveCaption() {
      let formData = new FormData();
      formData.append('file', this.captionObject);
      formData.append('filename', this.caption.filename);
      formData.append('training_video_id', this.id);
      formData.append('source_lang', this.caption.sourceLang);
      formData.append('label', this.caption.label);

      if (this.captionButtonState == 'save'){

        this.$axios.post('/supadmin/trainings/videos/captions', formData)
        .then((response) => {
            if (response.data.success) {
                this.getCaptionsByVideoID(this.id)
                this.clearInputCaption()
                this.$toast.success(response.data.message)
            }else{
                this.$toast.error(response.data.message)
            }
        })
        .catch()
      } else {

          if (this.trainingVideo.assignSequence != this.trainingVideo.oldSequence) {
              formData.append('assign_sequence', this.trainingVideo.assignSequence);
          }

          this.$axios.put('/supadmin/trainings/videos/captions/' + this.caption.id, formData)
          .then((response) => {
              if (response.data.success) {
                  this.getCaptionsByVideoID(this.id)
                  this.clearInputCaption()
                  this.$toast.success(response.data.message)
              }else{
                  this.$toast.error(response.data.message)
              }
          })
          .catch()
      }
    },

    deleteCaption(item) {
     if(confirm("Do you really want to delete this caption?")) {
        this.$axios.delete('/supadmin/trainings/videos/captions/' + item.ID)
        .then((response) => {
          if (response.data.success){
            this.$toast.success(response.data.message)
            this.getCaptionsByVideoID(this.id)
            this.clearInputCaption()
          } else {
            this.$toast.error(response.data.message)
          }
        })
        .catch()
      }
    },

    deleteTrainingVideo(id) {
      if(confirm("Do you really want to delete this video?")) {
          this.$axios.delete('/supadmin/trainings/videos/' + id)
          .then((response) => {
              if (response.data.success){
                  this.$toast.success(response.data.message)
                  this.getData();
              } else {
                  this.$toast.error(response.data.message)
              }
          })
          .catch()
      }
    },

    //captions axios requests
    getCaptionsByVideoID(id){
      this.captionLoading = true;
      this.captionDialog = true;
      this.id = id
      this.$axios.get('/trainings/users/' + this.$store.state.auth.jwtPayload.user_id +'/videos/'+ this.id +'/captions')
      .then((response) => {
          if (response.data.success){
              this.captions = response.data.captions;
              this.captionLoading = false;
          } else {
            this.$toast.success( response.data.message)
          }
      })
      .catch()
    },

    takeawayHandler({files}) {
      this.takeawayObject = files
      // this.trainingVideo.takeaway = files
    },

    tooltipText(archived) {
      return archived ? 'Click to un-archive video' : 'Click to Archive video';
    },

    removeFile(id) {
      if(confirm("Do you really want to delete this takeaway?")) {
        this.$axios.delete('/supadmin/trainings/videos/takeaway/' + id)
        .then((response) => {
          if (response.data.success){
            this.trainingVideo.takeaway = "";
            this.$toast.success(response.data.message)
          } else {
            this.$toast.error(response.data.message)
          }
        })
        .catch()
      }
    }
  },

  computed: {
    setUploadVideoButtonText() {
      return this.fileName ? this.fileName : 'Upload';
    },

    setUploadThumbnailButtonText() {
      return this.thumbName ? this.thumbName : 'Select Thumbnail';
    },
    setUploadCaptionButtonText() {
      return this.captionName ? this.captionName : 'Select Caption';
    },
  },

  watch: {
    search: debounce(function() {
      this.trainingVideos = [];
      this.getData();
    }, 600),

    sortBy(){
      this.getData();
    }
  }

}
</script>


<style scoped>
.form-control{
  -webkit-border-radius: 0px;
     -moz-border-radius: 20px;
          border-radius: 20px;
}
.btn-create {
  -webkit-border-radius: 20px;
     -moz-border-radius: 20px;
          border-radius: 20px;
  font-size:13px;
  font-weight: 900;
  padding-right: 15px;
  padding-left: 15px;
  margin-bottom: 0px;
}

.btn-square {
  -webkit-border-radius: 0px;
     -moz-border-radius: 0px;
          border-radius: 0px;
  border:1px solid #00A0C1;
}

::-webkit-input-placeholder {
   font-size: 14px!important;
}

:-moz-placeholder { /* Firefox 18- */
      font-size: 14px!important;
}
::-moz-placeholder {  /* Firefox 19+ */
      font-size: 14px!important;
}

.video {
  width:100%;
}

/* buttons override */
.btn-circle-danger {
	width: 30px;
	height: 30px;
	padding: 6px 0px;
	border-radius: 15px;
	text-align: center;
	font-size: 12px;
	line-height: 1.42857;
	border: 1px solid #EB1C24;
	color: #EB1C24;
}

 .btn-circle-danger:hover {
	border: 1px solid #EB1C24;
	color: #EB1C24;
}

.btn-circle-danger:focus{
	border: 1px solid #EB1C24;
	color: #EB1C24;
}

.text-default{
	color: #435666;
}

div.inline { float:left;}

.form-check-input:checked {
    background-color: #00a0c1;
    border-color: #00d3fd;
}

td {
  white-space: normal !important;
  word-wrap: break-word;
}

table {
  table-layout: fixed;
}

.fileList {
   border: 2px solid #f5f5f5;
   border-radius: 10px;
}

.removeFile {
   color: red;
}

.removeFile:hover {
   cursor: pointer;
}

</style>

<style scoped>
:deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep(.modal-content) {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 30%;
}
:deep(.modal-content-caption) {
  position: relative;
  display: flex;
  flex-direction: column;
  /* max-height: 90%; */
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 40%;
}
.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.2rem;
  font-weight: 700;
}
.modal__content {
  flex-grow: 1;
  overflow:hidden;
  overflow-y:auto;
}
.modal__content-schedule {
  flex-grow: 1;
  overflow:hidden;
  overflow-y:auto;
}
.modal__action {
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 1rem 0 0;
}
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}

@media screen and (max-width: 900px) {

:deep(.modal-content-schedule) {
  width: 95%;
}

:deep(.modal-content) {
  width: 95%;
}
}
/* Common styles for icons */
.custom-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0; /* Remove padding to avoid extra spacing */
  border-radius: 50%; /* Make the button round */
}

.custom-icon-btn svg {
  width: 20px;
  height: 20px;
}

/* Adjust the size of the edit icon */
.custom-icon-btn i.fa-pen {
  font-size: 14px;
}

/* The container holding all buttons */
.inline-block {
  display: flex;
  align-items: center; /* Vertically center the items */
  flex-wrap: wrap; /* Allow icons to wrap to the next line */
  gap: 5px; /* Add some spacing between the stacked icons */
}

/* Custom slider styles */
.custom-slider {
  position: relative;
  width: 42px;
  height: 22px;
  margin-right: 5px; /* Add some space between the slider and other icons */
}

.custom-slider .slider {
  position: absolute;
  top: 1px;
  left: 1px;
  width: 40px; /* Adjust the width of the slider background */
  height: 20px; /* Adjust the height of the slider background */
  background-color: #B5DAC6;
  border-radius: 11px;
  cursor: pointer;
  transition: 0.4s;
}

.custom-slider .slider-button {
  position: absolute;
  top: 0px;
  left: 1px;
  width: 20px; /* Adjust the width of the slider button */
  height: 20px; /* Adjust the height of the slider button */
  background-color: #00B972; /* Slightly different shade of green */
  border-radius: 50%;
  transition: 0.4s;
}

/* Move the slider button when it's checked (toggled on) */
.form-check-input:checked + .slider .slider-button {
  transform: translateX(20px);
  background-color: #00B972; /* Green color for the checked/active state */
}

/* Adjust the background color when the slider is toggled off (unchecked) */
.form-check-input:not(:checked) + .slider .slider-button {
  background-color: grey; /* Grey color for the unchecked/inactive state */
  transform: translateX(0); /* Reset transform when unchecked */
}

/* Adjust the background color when the slider is toggled off (unchecked) */
.form-check-input:not(:checked) + .slider  {
  background-color: #bebebe; /* Grey color for the unchecked/inactive state */
  transform: translateX(0); /* Reset transform when unchecked */
}

/* Hide the default checkbox input */
.form-check-input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* Media Query for smaller screen sizes */
@media screen and (max-width: 768px) {
  .inline-block {
    flex-wrap: wrap; /* Allow icons to wrap to the next line */
  }

  .custom-icon-btn i.fa-pen {
    font-size: 16px; /* Adjust the size as needed */
  }

  /* Adjust the size of the slider button for smaller screens */
  .custom-slider .slider-button {
    width: 18px;
    height: 18px;
  }

  /* Adjust the size of other icons for smaller screens */
  .custom-icon-btn svg {
    width: 14px;
    height: 14px;
  }
}
</style>